<template>
  <!-- 管理员-案件管理 -->
  <div class="main-css">
    <div class="main-box">
      <!--    标题-->
      <div class="title-css">{{ $t("caseManagement") }}</div>
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("new")
        }}</el-button>
        <el-dropdown @command="handleUpdateJobStatus">
          <el-button type="primary" class="button-css">
            {{ $t("stateChange") }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item1, index) in statusData"
              :key="item1.code"
              :command="item1"
              >{{ item1.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="button-css" @click="deleteCase">{{
          $t("delete")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 95%"
          height="420"
          empty-text=" "
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
          @cell-click="jobNameDetail"
        >
          <el-table-column type="selection" width="45"></el-table-column>
          <!-- ----------------------案件番号---------------------- -->
          <el-table-column
            prop="jobId"
            label="案件番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
            <!--            <template slot-scope="scope">-->
            <!--              {{ scope.row.jobId }}-->
            <!--            </template>-->
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column
            prop="jobName"
            label="案件名"
            min-width="120"
            @cell-click="jobNameDetail"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
          </el-table-column>

          <!-- --------------------- 工作类别-------------------- -->
          <el-table-column
            prop="workType"
            label=" 職種カテゴリー"
            min-width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("typeOfWork") }}</p>
              <el-dropdown @command="handleCommandworkType">
                <span class="el-dropdown-link">
                  {{ workTypeName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in workTypeData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.workType_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpworkType_dictText }}
              </span>
            </template>
            <!--            <template slot-scope="scope">
                          {{ scope.row.agencyAttribute }}
                        </template> -->
          </el-table-column>
          <!-- ----------------------勤務地---------------------- -->
          <el-table-column
            prop="workSpace"
            label="勤務地"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("workLocation") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @change="mohuSearch"
              />
            </template>
          </el-table-column>
          <!-- ----------------------医療機関 ---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医療機関"
            min-width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("medicalInstitution") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
          </el-table-column>
          <!-- ----------------------勤務時間---------------------- -->
          <el-table-column
            prop="workTime"
            label="勤務時間"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("dutyTime") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.workTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------目標採用時期---------------------- -->
          <el-table-column
            prop="principalTime"
            label="目標採用時期"
            :sortable="'custom'"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("targetRecruitmentTime") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.principalTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------採用人数---------------------- -->
          <el-table-column
            prop="recruitNumber"
            label="採用人数"
            :sortable="'custom'"
            min-width="110"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("numberOfHires") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
          </el-table-column>
          <!-- ----------------------勤務内容---------------------- -->
          <el-table-column
            prop="workContent"
            label="勤務内容"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("workContent") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
          </el-table-column>
          <!-- ----------------------福利厚生---------------------- -->
          <el-table-column
            prop="welfareTreatment"
            label="福利厚生"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("welfare") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
          </el-table-column>
          <!-- ----------------------採用条件---------------------- -->
          <el-table-column
            prop="employmentConditions"
            label="採用条件"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("employmentConditions") }}</p>
              <el-input
                v-model="searchData11"
                size="mini"
                placeholder="Search"
              />
            </template>
          </el-table-column>
          <!-- ----------------------其他---------------------- -->
          <el-table-column
            prop="other"
            label="その他"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("other") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
          </el-table-column>
          <!-- ----------------------雇佣形态1---------------------- -->
          <el-table-column
            prop="employmentForm1"
            label="雇用形態1"
            width="90"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("employmentForm") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.employmentForm1_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpemploymentForm1_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------雇佣形态2---------------------- -->
          <el-table-column
            prop="employmentForm2"
            label="雇用形態2"
            width="90"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("employmentForm2") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.employmentForm2_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpemploymentForm2_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------雇用形態3---------------------- -->
          <el-table-column
            prop="employmentForm3"
            label="雇用形態3"
            width="90"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("employmentForm3") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.employmentForm3_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpemploymentForm3_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------雇用形態4---------------------- -->
          <el-table-column
            prop="employmentForm4"
            label="雇用形態4"
            width="90"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("employmentForm4") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.employmentForm4_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpemploymentForm4_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------给予---------------------- -->
          <el-table-column
            prop="hourSalary"
            label="给予"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("give") }}</p>
              <p style="height:27px;width:100%"></p>
              <!-- <el-dropdown @command="handleCommandhourSalary">
                <span class="el-dropdown-link">
                  {{ hourSalaryName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in hourSalaryData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.hourSalary_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jphourSalary_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------最低額---------------------- -->
          <el-table-column
            prop="startSalary"
            label="最低額"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("minimum") }}</p>
              <el-input
                v-model="searchData17"
                size="mini"
                placeholder="Search"
              />
            </template>
          </el-table-column>
          <!-- ----------------------最高額---------------------- -->
          <el-table-column
            prop="endSalary"
            label="最高額"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("maximumAmount") }}</p>
              <el-input
                v-model="searchData18"
                size="mini"
                placeholder="Search"
              />
            </template>
          </el-table-column>
          <!-- ----------------------申込日付---------------------- -->
          <el-table-column
            prop="createTime"
            label="申込日付"
            :sortable="'custom'"
            min-width="110"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("applyForDailyPayment") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.createTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------掲載日付---------------------- -->
          <el-table-column
            prop="endTime"
            label="掲載日付"
            :sortable="'custom'"
            min-width="110"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("payonTheDay") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.endTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------参观数---------------------- -->
          <el-table-column
            prop="visitedTime"
            label="観観数"
            :sortable="'custom'"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("numberOfVisits") }}</p>
              <p style="height:27px;width:100%"></p>
            </template>
          </el-table-column>
          <!-- ----------------------状態---------------------- -->
          <el-table-column
            label="状態"
            :sortable="'custom'"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <p style="height:27px;width:100%"></p>
              <!-- <el-dropdown @command="handleCommandjobReviewStatus">
                <span class="el-dropdown-link">
                  {{ jobReviewStatusName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in jobReviewStatusData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.reviewStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpreviewStatus_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------用户名------------------ -->
          <el-table-column
            prop="userName"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("userName") }}</p>
            </template>
          </el-table-column>

          <!-- --------------------------操作-------------------------- -->
          <el-table-column label="操作" width="170" fixed="right">
            <template slot="header">
              <p>{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.reviewStatus == '1'"
              >
                <button
                  size="mini"
                  class="save-button"
                  @click="handleUpdateJobStatusOk(scope.row)"
                >
                  yes
                </button>
                <button
                  size="mini"
                  class="save-button"
                  @click="handleUpdateJobStatusNo(scope.row)"
                >
                  no
                </button>
              </el-button>
              <el-button v-else type="text" size="mini">
                <button
                  size="mini"
                  class="save-button"
                  @click="handleEditClick(scope.row.jobId)"
                >
                  {{ $t("edit") }}
                </button>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--    分页部分-->
        <div class="pagination">
          <div class="pagination-main">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout=" prev, pager, next"
              :total="totalNum"
              :page-size="pageSize"
            >
            </el-pagination>
            <!-- Rows per page -->
            <div class="rowsPage">
              <span>Rows per page</span>
              <div class="rowsPage-css">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ pageSize
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">7</el-dropdown-item>
                    <el-dropdown-item command="b">15</el-dropdown-item>
                    <el-dropdown-item command="c">20</el-dropdown-item>
                    <el-dropdown-item command="d">25</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- --------------------------新增dialog-------------------------- -->
      <div>
        <el-dialog :visible.sync="addDialogVisible" width="1200px">
          <div class="add-dialog-css">
            <div class="main-css-cp">
              <div class="main-box-cp">
                <!-- 主要信息部分 -->
                <div class="main-info-box">
                  <!-- 左边部分 -->
                  <div class="left-box">
                    <!-- 左边第一行 -->
                    <div class="left-inline-box">
                      <div class="left-top-title">
                        {{ $t("viewJobInformation") }}
                      </div>
                      <div class="left-bottom-title">
                        {{ this.tableDataDetail.jobName }}
                      </div>
                    </div>
                    <!-- 左边照片行 -->
                    <div class="left-img-box">
                      <img
                        :src="imgList1"
                        alt=""
                        @error="
                          e => {
                            e.target.src = require('@/assets/defaultImg.png');
                          }
                        "
                      />
                      <img
                        :src="imgList2"
                        alt=""
                        @error="
                          e => {
                            e.target.src = require('@/assets/defaultImg.png');
                          }
                        "
                      />
                      <img
                        :src="imgList3"
                        alt=""
                        @error="
                          e => {
                            e.target.src = require('@/assets/defaultImg.png');
                          }
                        "
                      />
                    </div>
                    <!--左边第三行 -->
                    <div class="label-line-box">
                      <div :class="label1 ? 'label-box' : 'label-box-active'">
                        {{ $t("fullTimeEmployee") }}<span>×</span>
                      </div>
                      <div :class="label2 ? 'label-box' : 'label-box-active'">
                        {{ $t("partTimeJob") }}<span>×</span>
                      </div>
                      <div :class="label3 ? 'label-box' : 'label-box-active'">
                        {{ $t("specificSkill") }}<span>×</span>
                      </div>
                      <div :class="label4 ? 'label-box' : 'label-box-active'">
                        {{ $t("technicalInternTrainee") }}<span>×</span>
                      </div>
                    </div>
                    <!-- 左边第四行 -->
                    <div class="inline-normal-box">
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("occupationCategory") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.workType_dictText }}
                        </div>
                      </div>
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("workLocation") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.workSpace }}
                        </div>
                      </div>
                    </div>
                    <!-- 左边第五行 -->
                    <div class="inline-normal-box">
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("employmentForm") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.employmentForm1_dictText }}
                          {{ this.tableDataDetail.employmentForm2_dictText }}
                          {{ this.tableDataDetail.employmentForm3_dictText }}
                          {{ this.tableDataDetail.employmentForm4_dictText }}
                        </div>
                      </div>
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("dutyTime") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.workTime }}
                        </div>
                      </div>
                    </div>
                    <!-- 左边第六行 -->
                    <div class="inline-normal-box">
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("salary") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.hourSalary_dictText }}
                          {{ tableDataDetail.startSalary }} ~
                          {{ tableDataDetail.endSalary }}
                        </div>
                      </div>
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("numberOfHires") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.recruitNumber }}名
                        </div>
                      </div>
                    </div>
                    <!-- 左边第七行 -->
                    <div class="inline-normal-box">
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("recruiter") }}
                        </div>
                        <div class="normal-bottom-box-name">
                          {{ this.tableDataDetail.userName }}
                        </div>
                      </div>
                      <div class="normal-box">
                        <div class="normal-top-box-name">
                          {{ $t("targetRecruitmentTime") }}
                        </div>
                        <div
                          class="normal-bottom-box-name"
                          v-if="this.tableDataDetail.principalTime"
                        >
                          {{ this.tableDataDetail.principalTime.split(" ")[0] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 右边部分 -->
                  <div class="right-box">
                    <!-- button -->
                    <div class="line-button-box-cp">
                      <button
                        class="button-css2"
                        @click="releaseJobClick(tableData.jobId)"
                      >
                        {{ $t("jobApplyView") }}
                      </button>
                    </div>
                    <!-- 第一行 -->
                    <div class="right-normal-box">
                      <div class="right-box-top">{{ $t("workContent") }}</div>
                      <div class="right-box-bottom">
                        {{ this.tableDataDetail.userName }}
                      </div>
                    </div>
                    <!-- 第二行 -->
                    <div class="right-normal-box">
                      <div class="right-box-top">
                        {{ $t("employmentConditions") }}
                      </div>
                      <div class="right-box-bottom">
                        {{ this.tableDataDetail.employmentConditions }}
                      </div>
                    </div>
                    <!-- 第三行 -->
                    <div class="right-normal-box">
                      <div class="right-box-top">{{ $t("welfare") }}</div>
                      <div class="right-box-bottom">
                        {{ this.tableDataDetail.welfareTreatment }}
                      </div>
                    </div>
                    <!-- 第四行 -->
                    <div class="right-normal-box">
                      <div class="right-box-top">{{ $t("other") }}</div>
                      <div class="right-box-bottom">
                        {{ this.tableDataDetail.other }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUrlFromOSS,
  jobInfoStatusChange,
  batchDeleteInfoAdmin,
  fuzzyQuery,
  educationInfoFuzzyQuery,
  queryAll,
  medicalResumeDetailInfo,
  updateJobStatus,
  jobInfoQuery
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "administratorCaseManagement",
  components: {},
  data() {
    return {
      inputData1: "", //搜索框input内容
      tableData: [], //   table内容
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第5个搜索
      searchData6: "", //表格第6个搜索
      searchData7: "", //表格第7个搜索
      searchData8: "", //表格第8个搜索
      searchData9: "", //表格第9个搜索
      searchData10: "", //表格第10个搜索
      searchData11: "", //表格第11个搜索
      searchData12: "", //表格第12个搜索
      searchData13: "", //表格第13个搜索
      searchData14: "", //表格第14个搜索
      searchData15: "", //表格第15个搜索
      searchData16: "", //表格第16个搜索
      searchData17: "", //表格第17个搜索
      searchData18: "", //表格第18个搜索
      searchData19: "", //表格第19个搜索
      searchData20: "", //表格第20个搜索
      searchData21: "", //表格第21个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      dialogIsShow: false, //dialog弹窗标识
      idList: [],
      addDialogVisible: false,
      tableDataDetail: [],
      jobIdL: "",
      multipleSelection: [],
      statusData: [],
      totalNum: 0,
      imgList1: "",
      imgList2: "",
      imgList3: "",
      language: "",
      dataItem: "",
      workType: "",
      workTypeName: "All",
      workTypeCode: "",
      workTypeData: [],
      hourSalary: "",
      hourSalaryName: "All",
      hourSalaryCode: "",
      hourSalaryData: [],
      jobReviewStatus: "",
      jobReviewStatusName: "All",
      jobReviewStatusCode: "",
      jobReviewStatusData: [],
      label1: "",
      label2: "",
      label3: "",
      label4: ""
    };
  },

  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    //获取数据字典语言值方法
    this.getLanguage();
    this.getReviewStatus();
    // 案件全部查询 list
    this.allCase();
    this.getworkType();
    this.gethourSalary();
    this.getjobReviewStatus();

    // JSON.parse(window.localStorage.getItem('language'))
    // this.language=JSON.stringify(window.localStorage.getItem('language'))
    // console.log("转码后语言选择为"+JSON.stringify(window.localStorage.getItem('language')))
    // console.log(this.language)
  },
  computed: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    } //搜索部分的placeholder
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.getLanguage();
        this.getReviewStatus();
        // 案件全部查询 list
        this.allCase();
        this.getworkType();
        this.gethourSalary();
        this.getjobReviewStatus();
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.dataItem = "jobReviewStatus";
        this.workType = "workType";
        this.hourSalary = "hourSalary";
        this.jobReviewStatus = "jobReviewStatus";
      } else {
        this.dataItem = "jpjobReviewStatus";
        this.workType = "jpworkType";
        this.hourSalary = "jphourSalary";
        this.jobReviewStatus = "jpjobReviewStatus";
      }
    },
    //图片回显
    getUrlList(url, number) {
      console.log("url" + url + number);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            if (number == 0) {
              this.imgList1 = aesFecInfo.message;
              console.log("第一張：" + this.imgList1);
            } else if (number == 1) {
              this.imgList2 = aesFecInfo.message;
              console.log("第二張：" + this.imgList2);
            } else if (number == 2) {
              this.imgList3 = aesFecInfo.message;
              console.log("第三張：" + this.imgList3);
            }
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //获取jobReviewStatus下拉
    handleCommandjobReviewStatus(evt) {
      this.jobReviewStatusCode = evt.code;
      this.jobReviewStatusName = evt.name;
    },
    //获取workType下拉
    handleCommandworkType(evt) {
      this.workTypeCode = evt.code;
      this.workTypeName = evt.name;
    },
    //获取hourSalary下拉
    handleCommandhourSalary(evt) {
      this.hourSalaryCode = evt.code;
      this.hourSalaryName = evt.name;
    },
    //search
    inputSearch() {
      this.mohuSearch();
    },
    getjobReviewStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.jobReviewStatus
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据jobReviewStatus--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.jobReviewStatusData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.jobReviewStatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    gethourSalary() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.hourSalary
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据hourSalary--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.hourSalaryData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.hourSalaryData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    getworkType() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.workType
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据workType--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.workTypeData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.workTypeData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    //获取状态数据字典
    getReviewStatus() {
      var that = this;

      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: this.dataItem
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据review_status--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            for (var i = 1; i < aesFecInfo.data.length; i++) {
              that.statusData[i - 1] = aesFecInfo.data[i];
            }
            console.log("--------获当然是看获取的状态了--------");

            console.log(that.statusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    // 教育机构模糊查询 list
    mohuSearch() {
      const fakeInfo = {
        employmentConditions: this.searchData11,
        endSalary: this.searchData18,
        jobId: this.searchData1,
        jobName: this.searchData3,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        startSalary: this.searchData17,
        workSpace: this.searchData4,
        workType: this.hourSalaryCode
      };
      fuzzyQuery(fakeInfo)
        .then(res => {
          console.log("----管理员案件管理模糊查询列表信息----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            if (aesFecInfo.totalPage < this.currentPage) {
              this.currentPage = 1;
              this.mohuSearch();
            }

            this.totalNum = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----管理员案件管理模糊查询列表信息异常----");
          console.log(res);
        });
    },

    //详情
    jobNameDetail(row, column, cell, event) {
      console.log(event);
      console.log(column.label);
      console.log(row);
      var that = this;

      if (column.label == "案件名") {
        console.log(column.row);
        this.addDialogVisible = true;
        console.log(row.jobId);
        this.jobIdL = row.jobId;
        console.log("这是真的");
        console.log(this.jobIdL);

        var that = this;
        jobInfoQuery({
          jobId: this.jobIdL
        })
          .then(res => {
            if (res.data.code === "A0000") {
              console.log("详情成功");
              console.log(res);
              const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
              that.tableDataDetail = aesFecInfo.data[0];
              that.getUrlList(that.tableDataDetail.jobPhoto1, 0);
              that.getUrlList(that.tableDataDetail.jobPhoto1, 1);
              that.getUrlList(that.tableDataDetail.jobPhoto1, 2);
              console.log(that.tableDataDetail);
              console.log(aesFecInfo);
            } else {
              console.log(res);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },

    // 详情dialog close
    addDialogClose() {
      this.addDialogVisible = false;
    },

    // 案件所有查询 list
    allCase() {
      const fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryAll(fakeInfo)
        .then(res => {
          console.log("----案件所有列表信息----！！！");
          console.log("语言选择为" + window.localStorage.getItem("language"));
          console.log(this.language);
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalNum = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----案件所有列表信息失败----");
          console.log(res);
        });
    },

    //管理者变更案件状态接口
    handleUpdateJobStatus(evt) {
      var fakeInfo = {
        jobId: this.idList[0],
        reviewStatus: evt.code
      };

      jobInfoStatusChange(fakeInfo)
        .then(res => {
          console.log("--------管理者变更案件状态接口数据--------");
          console.log(fakeInfo);
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("解密后信息" + AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              message: AES.decrypt(res.data.data),
              type: "success"
            });
          }
          this.allCase();
        })
        .catch(res => {
          console.log("管理者变更案件状态接口异常:", res);
        });
    },

    //管理者案件通过审核状态接口ok
    handleUpdateJobStatusOk(row, column, cell, event) {
      console.log(row);
      console.log(row.jobId);

      var fakeInfo = {
        jobId: row.jobId,
        reviewStatus: 2
      };

      jobInfoStatusChange(fakeInfo)
        .then(res => {
          console.log("--------管理者变更案件状态接口数据ok--------");
          console.log(fakeInfo);
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("解密后信息" + AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              // message: '案件通过审核成功!',
              message: this.$t("successfulOperation"),
              type: "success"
            });
            this.allCase();
          }
        })
        .catch(res => {
          console.log("管理者变更案件状态接口异常:", res);
        });
    },

    // //管理者案件通过审核状态接口ok
    // handleUpdateJobStatusOk(row,column, cell, event) {
    //   console.log(row.userId)
    //   var that = row;
    //   axios
    //     .get('/api/modules-parent/jobInfo/jobInfoStatusChange',
    //       {
    //         params: {
    //           jobId: row.jobId,
    //           reviewStatus: 2,
    //         },
    //         headers:{
    //           'content-type': 'application/x-www-form-urlencoded',
    //           "token":localStorage.getItem("token")
    //         }
    //       })
    //     .then(function (res) {
    //       console.log("----测试true----")
    //       console.log(res)
    //     })
    //     .catch(function (error) {
    //       this.$message.error('操作失败。');
    //     })
    // },

    //管理者案件不通过审核状态接口
    handleUpdateJobStatusNo(row) {
      var fakeInfo = {
        jobId: row.jobId,
        reviewStatus: 3
      };

      jobInfoStatusChange(fakeInfo)
        .then(res => {
          console.log("--------管理者变更案件状态接口数据no--------");
          console.log(fakeInfo);
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log("解密后信息" + AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              message: this.$t("operationFailed"),
              type: "error"
            });
            this.allCase();
          }
        })
        .catch(res => {
          console.log("管理者变更案件状态接口异常:", res);
        });
    },
    //删除
    deleteCase() {
      if (this.idList.length < 1) {
        this.$message({
          message: this.$t("selectLeastOneMessage"),
          type: "warning"
        });
      } else {
        const data = {
          listId: this.idList
        };
        axios({
          method: "delete",
          url: "/api/modules-parent/jobInfo/deleteJobInfo",
          data: data,
          headers: {
            token: localStorage.getItem("token")
          }
        })
          .then(res => {
            if (res.data.code === "A0000") {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message.error(res.data.message);
              this.$message.error("删除失败");
            }
            this.allCase();
            console.log(res.data);
          })
          .catch(res => {
            console.log("-----删除后案件列表接口-----");
            console.log(res);
          });
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "minimum") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["minimum"] - b["minimum"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["minimum"] - a["minimum"]
          );
        }
      } else if (column.prop === "maximumAmount") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["maximumAmount"] - b["maximumAmount"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["maximumAmount"] - a["maximumAmount"]
          );
        }
      } else if (column.prop === "pageView") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageView"] - b["pageView"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageView"] - a["pageView"]
          );
        }
      }
    },

    //点击案件名跳转该案件应聘详情
    releaseJobClick() {
      console.log(this.tableDataDetail.jobId);
      this.$router.push({
        name: "administratorApplicationManagementOnlyCase",
        params: {
          jobId: this.tableDataDetail.jobId
        }
      });
    },

    //分页
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.mohuSearch();
    },
    //每页下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.mohuSearch();
    },
    //选择行数据
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].jobId);
      }
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleAddClick() {
      console.log("＋新たなbutton");
      this.$router.push("/adminPostAddPageProgressOne");
    },
    handleAlterClick() {
      console.log("状態変更button");
    },
    handleDeleteClick() {
      console.log("削除button");
    },
    handleEditClick(jobId) {
      console.log("编辑button");
      console.log(jobId,this.tableDataDetail.jobId);
      this.$router.push({
        name: "adminJobRevise1",
        params: {
          jobId: jobId,
          fromPage:1
        }
      });
    },
    //筛选
    handleClickOne(val) {
      if (val === "class1") {
        console.log("看護職");
      } else if (val === "date1") {
        console.log("2022.03.05");
      } else if (val === "give1") {
        console.log("時給");
      } else if (val === "min1") {
        console.log("25");
      } else if (val === "max1") {
        console.log("05");
      } else if (val === "applyDate1") {
        console.log("2022.03.05");
      } else if (val === "publish1") {
        console.log("2022.03.05");
      } else if (val === "visit1") {
        console.log("2763");
      }
    },
    //状态筛选
    handleClickTwo(val) {
      if (val === "a") {
        console.log("公開中");
      } else if (val === "b") {
        console.log("关闭");
      }
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-left: 30px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  position: absolute;
  width: 92%;
  margin-top: 10px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.operate {
  height: 51px;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.table-img-css {
  border-radius: 50%;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  /* position: relative; */
  text-align: center;
}

.table /deep/ .caret-wrapper {
  /* display: inline-block; */
  position: absolute;
  top: -5px;
  right: -5px;
  /* width: 67px; */
}

.save-button {
  width: 69px;
  height: 28px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.pagination {
  width: 95%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.add-dialog-css {
  width: 1100px;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.add-dialog-css /deep/ .el-form {
  width: 250px;
}

.add-dialog-css /deep/ .el-form-item {
  margin-bottom: 5px;
}

dialog /deep/ .el-dialog__body {
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding: 0px;
}

dialog /deep/ .el-dialog__header {
  /* padding: 30px 20px; */
  padding: 0px;
}

/*以下为弹窗复制css*/
.main-css-cp {
  width: 100%;
  height: 100%;
  background: #fff;
}

.main-box-cp {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 0 55px;
  box-sizing: border-box;
}

.top-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 20px;
}

.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}

.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}

.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}

.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}

.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}

.line-center-normal {
  width: 160px;
  height: 2px;
  background: #dce3e9;
}

.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}

.main-info-box {
  width: 100%;
  height: 550px;
  display: flex;
}

.left-box {
  width: 50%;
}

.left-inline-box {
  height: 56px;
  width: 100%;
}

.left-top-title {
  height: 22px;
  line-height: 22px;
  width: 441px;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
}

.left-bottom-title {
  height: 34px;
  line-height: 34px;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}

.left-img-box {
  height: 114px;
  width: 95%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.left-img-box img {
  height: 114px;
  width: 150px;
}

.left-label-box {
  height: 30px;
  width: 95%;
  background: #fff;
  margin-top: 5px;
}

.label-line-box {
  width: 95%;
  height: 30px;
  margin-top: 5px;
}

.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  color: #fff;
  margin-right: 20px;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.inline-normal-box {
  height: 60px;
  width: 100%;
  background: #fff;
  display: flex;
  margin-top: 15px;
}

.normal-box {
  width: 50%;
  height: 60px;
  padding: 0 15px;
  box-sizing: border-box;
}

.normal-top-box-name {
  width: 220px;
  height: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #686868;
}

.normal-bottom-box-name {
  height: 35px;
  width: 228px;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: #686868;
}

.right-box {
  flex: 1;
  padding-top: 75px;
  box-sizing: border-box;
  padding-left: 60px;
}

.right-normal-box {
  height: 105px;
  width: 95%;
  margin-bottom: 15px;
}

.right-box-top {
  height: 22px;
  line-height: 22px;
  width: 441px;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
}

.right-box-bottom {
  height: 80px;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.line-button-box-cp {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}

.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}

.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

.el-table__empty-block {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABACAMAAADbASJGAAABPlBMVEUAAADX19fa2trZ2dna2trZ2dn19fX19fXt7e319fX19fX19fXb29vZ2dnZ2dn29vb19fX29vb8/PzY2NjZ2dn29vb19fX19fXZ2dnZ2dnZ2dnZ2dn19fXa2tra2tr4+Pja2tr19fXZ2dn29vbb29vZ2dn19fX29vb19fXZ2dn19fX19fXZ2dn29vb29vbX19f29vbi4uLZ2dnj4+Ph4eHZ2dnZ2dnZ2dn29vb09PTZ2dn19fXa2trZ2dn19fXZ2dn19fX19fX29vb19fXZ2dn09PTY2Nj19fXa2tr39/fX19fd3d3Z2dnY2Nj19fXZ2dn29vbh4eH09PT29vbY2NjZ2dnZ2dn09PTY2NjZ2dn09PT19fXX19f6+vr19fXZ2dnp6eni4uLo6Ojg4ODk5OTx8fHt7e3r6+v4+Pjd3d2+WHiwAAAAXXRSTlMAQL+/74DlRhnp1bf85qKLfmMRBvv18KGHamFQTEszLh/89dzc186+sq2ZlV1XUjc2KCUR9OzSzMfBtLCpmpGOgHpxbmdfVT06Hgz84NPFxLGwqKeYk3h2dnFdSi2FEAZaAAACXElEQVRYw+3U11LjQBCF4WMbW3LC2YAxxuScc1xy2JyzuiUHDO//AqsLahEYSyNpuKH4rlXzV7V6Bk6WA46q8GdgjAWsl+BDhbtLAUd9YzwAz/5yCCKWhnkZHq3wW4jJMefgzXAeopY5CU9GWYWwAIfgwQcOwIUSf4Nru3wCV8LcB5d6+RVc6na7yH08BddCXIEL/RyEe7lRrkJYJf8OXlTzYznhS5hMrsCTBfEpb+Qv4FG/6L5s8yw8O+HvELDHv+BDmEsiH/XClz0ecL4gX+HTdteC04+bgl/qxnrVdgXXgq/hWyUZsjuli9vsOq7abJDbhOwihv7QKoed3sWE8ZBDRGvTGF6CjQtuaG1cR5r2O93LTQkRLdFtO62EJiNiBGEjaEiJNNZgo6smJaLzGTr6yU0pkes3yX50cMarmpSI1kxwsANONCVFNNKNDlqkeY+Ie4k8h0hQViT8EnmJPNvI0qisyKdLPCY7vx+juqxIjcZT5SzuW9yPkklixBRNDeLO3CSZpEdMPcptYjBO9FQRM3MJ02mB/jNupDSuLRGKngIKWdT4WkaEWCeLc8TJ4oqvZETMY8hiBhNkVa/LiNTrZDWNObJqccN/o8EtsioDM2RV45uG7kvthnW6Py3T7yhZ6Ab7ZLTIIjZ/e1FSEXoiscPs3cN1/J6ewEQmh3uUdLxIEhV3DhU85vzHRymDi+wcL8KOWk5P+ihFJtNlFUJUJXPQMzEyRMIKsXjPQUZR4Z66+Gcuc5ROTX+Ob22Ox0Yi0WJhaKhQjEZGYuObW/Ev06n0UWZeGczCzj/Kd2oUicxurAAAAABJRU5ErkJggg==");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 75px;
  margin-top: 25px;
  margin-bottom: 60px;
  /*span{*/
  /*  position: relative;*/
  /*  top: 50px;*/
  /*}*/
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorCaseManagement/index.vue